<template>
    <div class="sanitationRate" @click="showImgView=false">
        <div class="query-content">
            <el-form :model="queryformdata" inline>
                <el-form-item label="楼栋">
                    <el-select v-model="queryformdata.houseId" placeholder="请选择楼栋" style="width:180px;" :disabled="HouseByManagerUserCombobox.length < 2" @change="queryData">
                        <el-option v-for="item in HouseByManagerUserCombobox" :key="item.houseId" :label="item.houseName" :value="item.houseId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryformdata.status" style="width:120px;" @change="queryData">
                        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker ref="startTime" :clearable="false" v-model="queryformdata.date" type="date" value-format="yyyy-MM-dd" style="width:180px;" @change="queryData">
                    </el-date-picker>
                </el-form-item>
                <el-form-item style="height: 43px;">
                    <el-input class="input" placeholder="请输入宿舍名称查询" v-model="queryformdata.dormitoryName">
                        <el-button slot="append" icon="el-icon-search" @click="queryData">查询</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item style="margin-right:0">
                    <el-button type="primary" icon="el-icon-upload" @click="openImportDialog">导入卫生</el-button>

                </el-form-item>
            </el-form>
        </div>
        <div class="container" v-show="floorList.length > 0">
            <el-row :gutter="20" style="width: 100%;    margin-left: -0px;    margin-right: -10px; padding-top: 20px;">

                <el-col :span="4">
                    <div class="ldxz">
                        <ul>
                            <li v-for="(item,index) in floorList" :key="item.floorId" :class="classObject(index)" @click="ldxzclick(item,index)">
                                <span class="point" v-show="item.dormitoryList.some( x => x.status == 2)"> ·</span>{{item.floorName.substring(0,item.floorName.length-1)}}
                                <span style="font-size:12px;">楼</span>
                            </li>
                        </ul>
                        <div></div>
                    </div>

                </el-col>
                <el-col :span="20" style="padding-right:0;padding-left:0px;">
                    <ul class="room-list">

                        <li v-if="item.status==1" v-for="(item,index) in roomList" :key="index">
                            <div class="content">
                                <div class="title yp">
                                    <span class="circle"></span>已评
                                </div>
                                <div class="name">{{item.dormitoryName}}</div>
                                <div class="star">
                                    <el-rate disabled v-model="item.score"></el-rate>
                                </div>
                                <div v-if="item.score < 3" class="red">（不合格）</div>
                                <div v-if="item.score >= 4" class="green">（优秀）</div>
                                <div v-if="item.score >= 3 && item.score < 4" class="orange">（合格）</div>
                                <div class="edit-btn-box">
                                    <div class="mask"></div>
                                    <div class="btn" style="margin-top:65px;">
                                        <div>
                                            <el-button class="orange" @click="viewRateDetail(item)">查看详情</el-button>
                                        </div>
                                        <div>
                                            <el-button class="green" @click="editRate(item)">修改评级</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </li>
                        <li v-if="item.status==2" v-for="(item,index) in roomList" :key="index">
                            <div class="content">
                                <div class="title wp">
                                    <span class="circle"></span>未评
                                </div>

                                <span class="name">{{item.dormitoryName}}</span>
                            </div>
                            <div class="edit-btn-box">
                                <div class="mask"></div>
                                <div class="btn" style="margin-top:95px;">
                                    <el-button class="green" @click="addRate(item)">卫生评级</el-button>
                                </div>
                            </div>

                        </li>
                    </ul>

                </el-col>
            </el-row>
            <!--卫生评级 -->
            <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="卫生评级" :visible.sync="showRateDialog" width="620px" left class="rateForm" :before-close="claseDialog">
                <el-form ref="rateForm" label-width="100px" :model="rateForm" :rules="rateFormRules">
                    <div class="warning-wrapper">
                        <span class="el-icon-warning warning"></span>
                        带
                        <span class="red">*</span>号的为必填项!
                    </div>
                    <el-form-item label="评级对象:">
                        {{currentRoom.dormitoryName}}
                    </el-form-item>
                    <el-form-item class="score" label="卫生评级:" prop="score">
                        <el-rate v-model="rateForm.score" :disabled="dialogType === 2"></el-rate>
                        <span class="rateText green " v-if="rateText=='(优秀)'">{{rateText}}</span>
                        <span class="rateText orange" v-if="rateText=='(合格)'">{{rateText}}</span>
                        <span class="rateText red" v-if="rateText=='(不合格)'">{{rateText}}</span>
                    </el-form-item>
                    <el-form-item>
                        <div v-show="!(dialogType ==2 && !rateForm.scoreComment)" v-for="(item, index) in currentCommentList" :key="index" class="tips" :class="{'active': item.active}" @click="clickComment(index)">{{item.text}}</div>
                    </el-form-item>
                    <el-form-item label="上传照片:">
                        <ul class="pic">
                            <li v-for="(item, index) in imgList" :key="index">
                            	<div class="img-close" @click="closeImg(index)" v-show="dialogType!==2">×</div>
                                <img :src="`/suguan/oss/d/${item}?token=${token}`" @click="viewImg(item)">
                            </li>
                            <li v-if="dialogType !== 2 && imgList.length < 5" class="add">
                                <uploadfile @upload="acceptFile" acceptType=".jpg,.jpeg,.png" :maxFileSize="2048000" ifmultiple v-if="clearShow"></uploadfile>
                            </li>
                        </ul>
                        <span class="red" style="font-size:12px;">*最多上传5张照片!</span>

                    </el-form-item>
                    <el-form-item label="备注说明:" prop="remark">
                        <el-input v-if="dialogType !== 2" type="textarea" v-model="rateForm.remark" style="height:80px" maxlength="50" v-inputexclude="'\\s+'"></el-input>
                        <span v-else style="color: #666">{{rateForm.remark}}</span>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="comfirmSanitationRate">确定</el-button>
                    <el-button v-show="dialogType!==2" @click="cancelSanitationRate">取消</el-button>
                </span>
            </el-dialog>
        </div>
        <div v-show="floorList.length ===0" style="padding-top: 20px;text-align:center;color:#333;">
            暂无数据
        </div>
        <!-- 导入 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="importObj.title" :visible.sync="showImport" width="500px" left :before-close="cancelImportDialog">
            <div class="warning-wrapper">
                <span class="el-icon-warning warning"></span> 建议一次导入不超过1000条数据
            </div>
            <div class="import-dialog">
                <p class="red">{{importErrorMsg}}</p>
                <div>
                    <el-input readonly class="input-text" v-model="importFileName"></el-input>
                    <div class="rel-import-btn">
                        选择文件
                        <input ref="importFile" class="import-btn" type="file" @change="changeExl" />
                    </div>

                </div>
                <div class="down-tepmlate">
                    <i></i>
                    <a :href="importObj.url" :download="importObj.title + '模板.xlsx'">{{importObj.text}}</a>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="uploadFile">确定</el-button>
                <el-button @click="cancelImportDialog">取消</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="showImportSuccess" width="400px" left :title="importObj.title" :before-close="closeERRDialog">
            <div style="height:158px;padding:30px 50px;text-align: center">
                <div style="margin-bottom:20px;">
                    <span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span>
                </div>
                <p>导入成功
                    <span class="red">{{importObj.stotal}}</span>条;失败
                    <span class="red">{{importObj.etotal}}条</span>!</p>
                <div v-show="importObj.etotal > 0" class="down-tepmlate" style="padding-top:0;">
                    <i></i>
                    <a @click="downErrExl(importObj.errpath)">点击下载失败名单列表</a>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmDialog">确定</el-button>
            </span>
        </el-dialog>
        <div class="view-img" v-show="showImgView">
            <div class="mask"></div>
            <div class="img-content">
                <img :src="viewimgsrc">

            </div>
        </div>
    </div>
</template>

<script>
import { session } from '@/util'
import combotree from '@/components/combotree/combotree.vue'
import api from '@/api'
import uploadfile from '@/components/upload_img/uploadfile.vue'
import importUpload from '@/components/importUpload/importUpload.vue';


export default {
    components: {
        vCombotree: combotree,
        uploadfile,
        importUpload
    },
    props: {},
    data () {
        let token = session('token').accesstoken;
        let user = session('user');
        let validZero = function (rule, value, callback) {
            if (value === 0) {
                callback(new Error('请选择卫生评分'))
            } else {
                callback();
            };
        }
        return {
            importObj: {
                title: '',
                text: '',
                url: '',
                stotal: '',
                etotal: '',
                errpath: ''
            },
            role: user.tsr.roleCode,
            doNotInit: true,
            token: token,
            dialogType: 0, // 0新增1修改2查看
            queryformdata: {
                houseId: '',
                status: 2,
                date: '',
                dormitoryName: ''
            },
            deptProps: {
                label: 'directorName',
                children: 'nextLevels',
                isLeaf: 'leaf'
            },
            schoolOrganization: [],
            HouseByManagerUserCombobox: [],
            statusList: [{ id: 0, name: '全部' }, { id: 1, name: '已评' }, { id: 2, name: '未评' }],
            floorList: [],
            floorindex: null,
            isActive: 0,
            test: 3.7,
            showRateDialog: false,
            rateForm: {
                healthId: '',
                dormitoryId: '',
                remark: '',
                score: 0,
                scoreComment: '',
                imageList: ''
            },
            currentRoom: {},
            commentList: [
                [{ text: '地面有垃圾' }
                    , { text: '垃圾桶垃圾没有倒' }
                    , { text: '物品摆放很乱' }
                    , { text: '被子没有叠' }
                    , { text: '墙壁乱贴乱画' }
                ], [{ text: '地面基本干净' }
                    , { text: '物品摆放较为整齐' }
                    , { text: '卫生基本合格，继续加油保持' }]
                , [{ text: '地面干净，无残留垃圾' }
                    , { text: '物品摆放整齐' }
                    , { text: '被子叠放整齐' }
                    , { text: '墙壁干净，未发现乱贴乱画' }
                    , { text: '垃圾桶已倾倒干净' }]

            ],
            rateFormRules: {
                score: [{ required: true, validator: validZero, message: '请选择卫生评级', trigger: 'change' }]
            },
            showImportSuccess: false,
            showImport: false,
            importErrorMsg: '',
            FileList: [], // 头像上传
            zipFileList: [], // 图片压缩包上传
            File: null, // 最终上传的formdata
            importFileName: '',
            fileName: '',
            showImgView: false,
            viewimgsrc: '',
            clearShow:true,
        }
    },
    watch: {


    },
    computed: {
		rateText(){
			let str = ''
			if(this.rateForm.score<3){
				str = '(不合格)'
			}else if(this.rateForm.score>=4){
				str = '(优秀)'
			}else if(this.rateForm.score>=3 &&  this.rateForm.score < 4){
				str = '(合格)'
			}else{

			}
			return str
		},
        roomList () {
            if (this.floorindex !== null && this.floorList.length > 0) {
                var list = this.floorList[this.floorindex].dormitoryList;
                list.forEach(item => item.score = parseInt(item.score) || 0);
                return list;
            }
            return [];
        },
        currentCommentList () {
            var index = this.rateForm.score < 3 ? 0 : this.rateForm.score >= 4 ? 2 : 1;
            var list = this.commentList[index];
            list.forEach((item) => {
                this.$set(item, 'active', false);
            });
            return list;
        },
        imgList: {
            get () {
            	console.log(this.rateForm.imageList)
                return !this.rateForm.imageList ? [] : this.rateForm.imageList.split(',');
            },
            set (v) {
            	console.log(v)
                this.rateForm.imageList = v.join(',')
            }
        }
    },
    methods: {
        // 导入
        openImportDialog () {
            this.showImport = true;
            this.importObj = {
                title: '导入卫生评级',
                text: '点击下载卫生导入模板',
                url: '/static/卫生导入模板.xlsx'
            };
        },
        closeERRDialog (done) {
            this.queryData();
            done();
        },
        comfirmDialog () {
            this.queryData();
            this.showImportSuccess = false;
        },
        uploadFile () {
            if (!this.File || this.importFileName === '') {
                this.$message('请先选择文件！');
                return;
            }
            this.importErrorMsg = '';
            api.sanitationManage.importHealth(this.queryformdata.houseId, this.File).then((res) => {
                if (res.code === 0) {
                    if (this.$refs.importFile) {
                        this.$refs.importFile.value = '';
                    }
                    this.importFileName = '';
                    this.importErrorMsg = '';
                    this.File = null;
                    this.openImportSuccess(res.data.successCount, res.data.failCount, res.data.failFilePath);
                } else {
                    this.importErrorMsg = res.message;
                }
            })
        },
        changeExl (event) {
            if (event.target.value !== "") {
                var reg = new RegExp("(\.xls|\.xlsx)$");
                if (!reg.test(event.target.value)) {
                    this.$message('导入文件格式有误，请核查后再试！');
                    event.target.value = '';
                    //   this.importFileName
                    return;
                }
                var file = this.$refs.importFile.files;
                var formData = new FormData();
                formData.append('healthFile', file[0]);
                this.importFileName = file[0].name;
                this.File = formData;
            }
        },
        downErrExl (path) {
            api.common.downloadFailFile(path).then(res => {
                this.downFile(res, "错误记录文件下载.xls");
            });
        },
        openImportSuccess (s, e, path) {
            this.showImport = false;
            this.showImportSuccess = true;
            this.importObj.stotal = s;
            this.importObj.etotal = e;
            this.importObj.errpath = path;
        },
        downFile (response, name) {
            if (!response) {
                return;
            }
            let url = window.URL.createObjectURL(new Blob([response]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        cancelImportDialog () {
            this.showImport = false;
            this.importFileName = '';
            this.File = null;
            this.importErrorMsg = '';
            this.$refs.importFile.value = '';
        },
        closeImg(index){
        	let listStr = this.rateForm.imageList
        	let list = new Array()
        	list = listStr.split(',')
        	list.splice(index,1)
        	this.rateForm.imageList = list.join(',')
        },
        viewImg (item) {
            this.$nextTick(() => {
                this.$data.showImgView = true;
                this.viewimgsrc = `/suguan/oss/d/${item}?token=${this.token}`;
            })

        },
        clickComment (index) {
            if (this.dialogType !== 2) {
                this.currentCommentList[index].active = !this.currentCommentList[index].active;
            }
        },
        viewRateDetail (item) {
            this.dialogType = 2;
            api.sanitationManage.selectByHealthId(item.healthId).then((res) => {
                if (res.code === 0) {
                    this.currentRoom = item;
                    var data = res.data;
                    this.rateForm = {
                        healthId: data.healthId,
                        dormitoryId: data.dormitoryId,
                        remark: data.remark,
                        score: data.score,
                        scoreComment: data.scoreComment,
                        imageList: data.imageList
                    };
                    if (data.scoreComment) {
                        data.scoreComment.split(',').forEach((item) => {
                            this.currentCommentList.forEach((x) => {
                                if (x.text === item) x.active = true;
                            })
                        })
                    }

                    this.showRateDialog = true;

                } else {
                    this.$message(res.message)
                }
            })
        },
        addRate (item) {
            this.showRateDialog = true;
            this.dialogType = 0;
            this.currentRoom = item;
            this.rateForm = {
                dormitoryId: item.dormitoryId,
                remark: '',
                score: 0,
                scoreComment: '',
                imageList: ''
            };
        },
        editRate (item) {
            this.dialogType = 1;
            api.sanitationManage.selectByHealthId(item.healthId).then((res) => {
                if (res.code === 0) {
                    this.currentRoom = item;
                    var data = res.data;
                    this.rateForm = {
                        healthId: data.healthId,
                        dormitoryId: data.dormitoryId,
                        remark: data.remark,
                        score: data.score,
                        scoreComment: data.scoreComment,
                        imageList: data.imageList || ''
                    };
                    if (data.scoreComment) {
                        data.scoreComment.split(',').forEach((item) => {
                            this.currentCommentList.forEach((x) => {
                                if (x.text === item) x.active = true;
                            })
                        })
                    }

                    this.showRateDialog = true;

                } else {
                    this.$message(res.message)
                }
            })

        },
        comfirmSanitationRate () {
            this.$refs.rateForm.validate((validate, obj) => {
                if (validate) {
                    if (this.dialogType === 2) {
                        this.showRateDialog = false;
                    } else {
                        var list = [];
                        this.currentCommentList.forEach(x => {
                            if (x.active) {
                                list.push(x.text)
                            }
                        })
                        this.rateForm.scoreComment = list.join(',');
                        let param = {
                            healthId: this.currentRoom.healthId || undefined,
                            scoreDate: this.queryformdata.date,
                            dormitoryId: this.rateForm.dormitoryId,
                            imageList: this.rateForm.imageList || null,
                            remark: this.rateForm.remark || undefined,
                            score: this.rateForm.score,
                            scoreComment: this.rateForm.scoreComment || undefined
                        }
                        let key = this.dialogType === 0 ? 'addOne' : 'updateOne';
                        api.sanitationManage[key](param).then((res) => {
                            if (res.code === 0) {
                                this.cancelSanitationRate();
                                let floorIndex = this.floorindex;
                                this.queryData().then(() => {
                                    this.floorindex = floorIndex;
                                    this.isActive = floorIndex;
                                    });

                            } else {
                                this.$message(res.message)
                            }
                        })
                    }

                }

            })
        },
        claseDialog (done) {
            this.cancelSanitationRate();
            done();
        },
        cancelSanitationRate () {
            this.$refs.rateForm.resetFields();
            this.showRateDialog = false;
        },
        classObject (index) {
            if (this.isActive == index) {
                return "active";
            } else {
                return "";
            }
        },
        ldxzclick (floor, index) {
            this.isActive = index;
            this.floorindex = index;
        },
        queryRoomByName () {

        },
        // 部门学校树枝
        deptTreeNodeHandleClick (data, node, c) {
            console.log(data, node, c)
        },
        queryHouseByManagerUser () {
            return api.summary.queryHouseByManagerUser().then(res => {
                if (res.code == 0) {
                    this.HouseByManagerUserCombobox = res.data;
                } else {
                    this.$layer.msg(res.message);
                }
            });
        },
        getAllFloorDormitory (roomName = '') {
            let param = {
                houseId: this.houseId,
                dormitoryName: roomName
            };
            api.systemConfig.getAllFloorDormitory(param)
                .then((res) => {
                    if (res.code == 0) {
                        this.floorList = res.data;
                        this.initialFloorList = this.floorList;
                    }
                })
        },
        // 返回当天年月日
        _setCurrentTime () {
            var _padZero = function (str) {
                let start = str.length == 2 ? 0 : 1;
                return ("0" + str).substring(start);
            };
            let date = new Date();
            let year = date.getFullYear();
            let month = _padZero(date.getMonth() + 1);
            let day = _padZero(date.getDate());
            return [year, month, day].join("-");
        },
        queryData () {
            if (this.queryformdata.date === '') {
                this.$message('请选择日期!');
                return;
            }
            var key = `houseId=${this.queryformdata.houseId}&status=${this.queryformdata.status}&currentDate=${this.queryformdata.date}`;
            if (this.queryformdata.dormitoryName !== '') {
                key += '&dormitoryName=' + this.queryformdata.dormitoryName;
            }
            return api.sanitationManage.houseHealthGplot(key).then((res) => {
                if (res.code === 0) {
                    this.floorList = res.data || [{ dormitoryList: [] }];
                    this.floorindex = 0;
                    this.isActive = 0;

                } else {
                    this.$message(res.message);
                }
            })

        },
        acceptFile (files) {
        	this.clearShow = false
            var imgreg = /(.jpg|.png|.jpeg)$/
            for (const file of files) {
                if (!imgreg.test(file.name.toLocaleLowerCase())) {
                    this.$message('只能上传.jpg/.png/.jpeg格式的图片!');
                    return;
                }
            }
            if (files.length > 0) {
                files = files.length > 5 ? files.slice(0, 5 - this.imgList.length) : files;
                var index = 0;
                let request = () => {
                    if(files[index]) {
                        var formData = new FormData();
                        formData.append('file', files[index]);
                        formData.append('picExpireType', 4);
                        formData.append('prefix', 'student');
                        api.systemConfig.uploadFile(formData)
                            .then((res) => {
                                if (res.code == 0) {
                                    if (this.rateForm.imageList.length === 0) {
                                        this.rateForm.imageList += res.data;
                                    } else {
                                        this.rateForm.imageList += ',' + res.data;
                                    }
                                    this.$nextTick(() => {
                                        index++;
                                        if (this.imgList.length < 5) {
                                            request();
                                            return;
                                        }
                                    })
                                    // this.studentInfoForm.picPath = res.data;
                                    // this.studentInfoForm.relPicPath = `/suguan/oss/d/${res.data}?token=${res.token}`;
                                } else {
                                    this.$message(res.message);
                                }
                                this.clearShow = true
                            }).catch(() => {
                                this.$message('上传异常，请重新操作');
                            })
                    }
                   
                }
                request();
            }
        }
    },
    created () {
        this.queryformdata.date = this._setCurrentTime();
        this.queryHouseByManagerUser().then(() => {
            if (this.HouseByManagerUserCombobox && this.HouseByManagerUserCombobox.length) {
                this.queryformdata.houseId = this.HouseByManagerUserCombobox[0].houseId;
            }
            this.queryData();

        });
    },
    mounted () { }
}
</script>
<style lang="scss" >
.sanitationRate {
  padding-top: 10px;
  .warning-wrapper {
    margin-bottom: 24px;
    line-height: 20px;
  }
  .red {
    color: red;
  }
  .query-content {
    background-color: #d5e5ed;
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
    .el-form-item {
      margin-right: 40px;
      margin-bottom: 0;

      .el-form-item__content {
        vertical-align: middle;
      }
    }
    .input {
      width: 250px;
      float: right;
      margin-top: 5px;
      .el-input__inner {
        border: 1px solid #26aef3;
        border-right: none;
      }
      .el-input-group__append {
        border: 1px solid #26aef3;
        border-left: none;
        background-color: #26aef3;
        color: #fff;
      }
    }
  }
  .container {
    background: none;
    height: 100%;
    margin: auto;
    display: block;
    .ldxz {
      width: 180px;
      /*height: 575px;*/
      margin-top: 24px;
      background: white;

      ul {
        width: 100%;
        padding: 20px 0;
        border: 1px solid #ccc;
        border-radius: 4px;
        li {
          position: relative;
          height: 60px;
          line-height: 60px;
          list-style: none;
          text-align: center;
          background: white;
          color: #26aef3;
          font-size: 28px;
          cursor: pointer;

          .point {
            position: absolute;
            top: -13px;
            left: 58px;
            color: red;
            font-size: 60px;
          }
        }
        li.active {
          background: #26aef3;
          color: white;
        }
      }
    }
    .room-list {
      list-style: none;
      margin-left: 10px;
      li {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        list-style: none;
        width: 174px;
        height: 200px;
        margin: 0 20px 20px 0;
        border-radius: 6px;
        border: 1px solid #dbdbdb;
        background-color: #fafafa;
        cursor: pointer;
        &:nth-child(5n) {
          margin-right: 0;
        }
        &:hover {
          .edit-btn-box {
            display: block;
          }
        }

        .edit-btn-box {
          display: none;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          .mask {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
          }
          .btn {
            position: relative;
            width: 100%;
            z-index: 10;
            text-align: center;
            margin-right: 0;
            button {
              width: 80px;
              height: 36px;
              padding: 0;
              margin: 0 0 10px 0;
            }
            .green {
              color: #fff;
              background: #00cdcd;
              border-color: #00cdcd;
            }
            .orange {
              color: #fff;
              background: #ffb324;
              border-color: #ffb324;
            }
          }
        }

        .content {
          padding: 10px;
          text-align: center;
          .title {
            text-align: left;
            padding-bottom: 10px;
            border-bottom: 1px solid #dbdbdb;
            &.yp {
              color: #00cdcd;
              .cicrle {
                display: inline-block;
                vertical-align: middle;
                margin-right: 10px;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                background-color: #00cdcd;
              }
            }
            &.wp {
              color: red;
              .circle {
                display: inline-block;
                vertical-align: middle;
                margin-right: 10px;
                width: 15px;
                height: 15px;
                border-radius: 50%;
                background-color: red;
              }
            }
          }
          .star {
            margin-bottom: 10px;
          }
          .green {
            color: #00cdcd;
          }
          .orange {
            color: #ffb324;
          }

          .name {
            display: inline-block;
            margin: 45px 0 10px 0;
            font-size: 20px;
            color: #666;
          }
        }
      }
    }
  }
  .rateForm {

    textarea {
      height: 80px;
    }
     .rateText{
    	position: absolute;
    	z-index: -99;
    	top: 0px;
    	padding-left: 150px;
    }
    .img-close{
    	position: absolute;
    	border: 1px solid #F0B06A;
    	width: 18px;
    	height: 18px;
    	line-height: 15px;
    	font-size: 12px;
    	text-align: center;
    	border-radius: 50%;
        right: -8px;
    	top: -20px;

    }
    .red{
    	color:red;
    }
     .green {
            color: #00cdcd;
          }
      .orange {
        color: #ffb324;
      }

    .el-rate {
      margin-top: 10px;
    }
    .score {
      .el-form-item__error {
        top: 32px;
      }
    }
    .tips {
      display: inline-block;
      vertical-align: middle;
      padding: 0 8px;
      height: 28px;
      border-radius: 4px;
      background-color: #fff;
      color: #666;
      border: 1px solid #666;
      margin-right: 10px;
      line-height: 28px;
      cursor: pointer;
      &.active {
        background-color: #ffb324;
        color: #fff;
        border: 1px solid #ffb324;
      }
    }
    .pic {
        display: inline-block;
        vertical-align: bottom;
      li {
      	position: relative;
        display: inline-block;
        vertical-align: middle;
        width: 85px;
        height: 56px;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        .upload-file-wrapper {
          width: 100%;
          height: 100%;
          opacity: 0;
          .file {
            width: 100%;
            height: 100%;
          }
        }
      }
      .add {
        background: url('add.png') center center no-repeat;
      }
    }
  }
  .warning {
    color: #e6a23c;
  }
  .red {
    color: red;
  }
  .down-tepmlate {
    color: #26aef3;
    padding-top: 10px;
    i {
      display: inline-block;
      vertical-align: bottom;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background: url('../../../static/images/systemConfig/down.png') 0 0
        no-repeat;
    }
    a {
      text-decoration: underline;
      color: #26aef3;
      font-size: 13px;
    }
  }
  .import-dialog {
    padding: 0 20px 20px 20px;
    .input-text {
      width: 250px;
      margin-right: 10px;
    }
    .warning {
      color: #e6a23c;
      margin-right: 5px;
    }
    .rel-import-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 140px;
      height: 30px;
      color: #fff;
      background-color: #e6a23c;
      border-radius: 4px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      .import-btn {
        position: absolute;
        left: 0;
        width: 140px;
        height: 30px;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
  .view-img {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    z-index: 100000;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
      background-color: rgba(0, 0, 0, 0.7);
    }
    .img-content {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 11;
      cursor: pointer;
      img {
        max-width: 900px;
        max-height: 80vh;
        margin-top: 50vh;
        transform: translateY(-50%);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/sanitationManage/sanitationRate.vue